import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";

interface DatePickerProps {
  selectedDate: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  showTime?: boolean;
  filterTime?: (time: Date) => boolean;
  variant?: "inline" | "popup";
  shouldCloseOnSelect?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  selectedDate,
  onChange,
  minDate,
  maxDate,
  showTime = false,
  variant = "popup",
  filterTime,
  shouldCloseOnSelect = false,
}) => {
  const enhancedFilterTime = (time: Date) => {
    const currentDate = new Date();
    const hours = time.getHours();
    const isWithinBusinessHours = hours >= 10 && hours <= 23;
    if (!isWithinBusinessHours) {
      return false;
    }
    if (time.toDateString() === currentDate.toDateString()) {
      const currentHour = currentDate.getHours();
      const currentMinutes = currentDate.getMinutes();
      const timeHour = time.getHours();
      const timeMinutes = time.getMinutes();

      if (timeHour < currentHour) {
        return false;
      }
      if (timeHour === currentHour && timeMinutes < currentMinutes) {
        return false;
      }
    }

    return true;
  };

  const isInline = variant === "inline";

  return (
    <div className={`datepicker-container ${isInline ? "inline-container" : "popup-container"}`}>
      <ReactDatePicker
        selected={selectedDate}
        onChange={(date) => onChange(date || new Date())}
        dateFormat={showTime ? "dd/MM/yyyy h:mm aa" : "dd/MM/yyyy"}
        placeholderText="Select a date"
        minDate={minDate ?? new Date()}
        maxDate={maxDate}
        showTimeSelect={showTime}
        timeIntervals={30}
        timeCaption="Time"
        timeFormat="HH:mm"
        filterTime={showTime ? filterTime || enhancedFilterTime : undefined}
        className={isInline ? "inline-datepicker-input" : "popup-datepicker-input"}
        calendarClassName={isInline ? "inline-datepicker-calendar" : "popup-datepicker-calendar"}
        wrapperClassName={isInline ? "inline-datepicker-wrapper" : "popup-datepicker-wrapper"}
        inline={isInline}
        showTimeSelectOnly={false}
        withPortal={false}
        shouldCloseOnSelect={shouldCloseOnSelect || (!showTime && !isInline)}
        disabledKeyboardNavigation={false}
        key={`${variant}-${showTime ? "with-time" : "date-only"}`}
      />
    </div>
  );
};
